import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Select from 'components/global/AutocompleteSelect';
import { injectIntl } from 'react-intl';
import { headers } from '../../actions/defaults';
import { API_URL } from '../../environment';

const ClientSelect = ({ onChange, intl }) => {
  const [clients, setClients] = useState([]);
  const [selectValue, setSelectValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/practice/clients/client_selector`, headers())
      .then(response => {
        const options = response.data
          .map(client => ({ label: client.full_name, value: client.id }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setClients(options);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = value => {
    setSelectValue(value);
    onChange(value ? value.value : null);
  };

  const { formatMessage } = intl;
  return (
    <Select
      className="global-client-select"
      options={clients}
      value={selectValue}
      isClearable
      onChange={handleChange}
      isSearchable
      isLoading={loading}
      name="client"
      noOptionsMessage={() =>
        formatMessage({ defaultMessage: 'No results found' })
      }
      placeholder={formatMessage({ defaultMessage: 'Client ...' })}
    />
  );
};

ClientSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ClientSelect);
